// assets/js/components/revenue-calculator/state.js
//
// Mutable state container mirroring the spec's App() useState/useCallback
// slices, without React. index.js re-renders after every mutator call.
//
// See ./README.md for the step map, progressPercent/goBack behavior (incl. a
// known back-navigation asymmetry), and which exports here are dead code.

function createState() {
    return {
        step: 0,
        path: null,
        adv: 0,
        d: { promotes: [] },
        email: "",
        firstName: "",
        smbUsage: "",
        resultsConsent: false,
        marketingConsent: false
    };
}

function setField(state, key, value) {
    state.d[key] = value;
}

function toggleBool(state, key) {
    state.d[key] = !state.d[key];
}

function toggleArr(state, key, value) {
    var arr = state.d[key] || [];
    var idx = arr.indexOf(value);
    state.d[key] = idx === -1 ? arr.concat([value]) : arr.filter(function (x) { return x !== value; });
}

// Ported from the spec's pct() (App(), page 35).
function progressPercent(state) {
    var step = state.step, adv = state.adv, path = state.path;
    if (step === 0) return 0;
    if (step >= 1 && step <= 4) return Math.round(step / 7 * 100);
    if (step === 5) return 70;
    if (step === 6) return path === "quick" ? 85 : Math.round(70 + (adv + 1) * 5);
    if (step === 7) return 93;
    return 100;
}

// Ported from the spec's goBack() (App(), page 35), except Back from the lead gate:
// the spec always went to step 5, which on the advanced path skipped Advanced 3/3.
function goBack(state) {
    if (state.step === 7) {
        if (state.path === "advanced") { state.step = 6; state.adv = 2; return; }
        state.step = 5; return;
    }
    if (state.path === "quick") { state.step = 5; return; }
    if (state.step === 6 && state.adv > 0) { state.adv -= 1; return; }
    if (state.step === 6 && state.adv === 0) { state.step = 5; return; }
    state.step -= 1;
}

// Ported from the spec's LeadGate submit-disabled condition.
function canSubmitLead(state, isSMB) {
    if (!state.email || !state.resultsConsent) return false;
    if (!isSMB && !state.smbUsage) return false;
    return true;
}

module.exports = {
    createState: createState, setField: setField, toggleBool: toggleBool, toggleArr: toggleArr,
    progressPercent: progressPercent, goBack: goBack, canSubmitLead: canSubmitLead
};
